import Breadcrumb from '@/components/base/Breadcrumb';
import { Link } from 'react-router-dom';

interface BlogArticleLayoutProps {
  title: string;
  breadcrumb: { label: string; to?: string }[];
  jsonLdBlogPosting: Record<string, unknown>;
  jsonLdFAQ: Record<string, unknown>;
  jsonLdBreadcrumb: Record<string, unknown>;
  datePublished: string;
  dateModified: string;
  children: React.ReactNode;
  heroImage?: string;
}

export default function BlogArticleLayout({
  title,
  breadcrumb,
  jsonLdBlogPosting,
  jsonLdFAQ,
  jsonLdBreadcrumb,
  datePublished,
  dateModified,
  children,
  heroImage,
}: BlogArticleLayoutProps) {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdBlogPosting)}</script>
      <script type="application/ld+json">{JSON.stringify(jsonLdFAQ)}</script>
      <script type="application/ld+json">{JSON.stringify(jsonLdBreadcrumb)}</script>

      {/* Hero */}
      <section className="relative pt-24 pb-10 md:pt-28 md:pb-14 overflow-hidden">
        {heroImage ? (
          <>
            <img src={heroImage} alt={title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-primary-500/75"></div>
          </>
        ) : (
          <div className="absolute inset-0 bg-primary-500"></div>
        )}
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumb} light />
          <h1 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-white mt-4 mb-3 leading-tight">
            {title}
          </h1>
          <div className="flex items-center gap-3 text-white/70 text-sm font-body">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-line text-sm"></i>
            </span>
            <span>Publié le {datePublished}</span>
            <span className="text-white/40">·</span>
            <span>Mis à jour le {dateModified}</span>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 md:py-14">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <article className="prose prose-lg max-w-none font-body text-foreground-500 leading-relaxed">
            {children}
          </article>
        </div>
      </section>

      {/* CTA Final */}
      <section className="bg-background-100 py-12 md:py-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-lg md:text-xl font-heading font-bold text-primary-500 mb-3">
            Un problème de menuiserie dans l&apos;Hérault ?
          </h2>
          <p className="text-secondary-500 font-body text-sm md:text-base mb-6 max-w-lg mx-auto">
            Nos techniciens interviennent sous 24 à 48h dans tout le département. Devis gratuit, sans engagement, et garantie 10 ans sur nos réparations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+33980802242" className="btn-call text-sm px-6 py-3 whitespace-nowrap">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-sm"></i>
              </span>
              Appeler le 09 80 80 22 42
            </a>
            <Link to="/blog/" className="btn-devis text-sm px-6 py-3 whitespace-nowrap">
              Voir tous nos conseils
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}